import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/lib/lang";
import Home from "@/pages/Home";
import BookLanding from "@/pages/BookLanding";
import GoRedirect from "@/components/GoRedirect";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App" data-testid="app-root">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<BookLanding pageLang="en" />} />
            <Route path="/he/book" element={<BookLanding pageLang="he" />} />
            <Route path="/buy" element={<Navigate to="/book" replace />} />
            <Route path="/go/:store" element={<GoRedirect />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
